export default __webpack_public_path__ + "assets/images/Payment_04.9a274c.avif";